import CtaButtonGroup, { CtaType } from '@/components/molecules/CtaButtonGroup';
import Image from 'next/image';
import React from 'react';
interface CourseInfo {
  title: string;
  date: string;
  time: string;
  duration: string;
  language: string;
  instructorImage?: string;
}

interface WebinarRegistrationSuccessProps {
  courseInfo: CourseInfo;
  ctas: CtaType[];
}


const WebinarRegistrationSuccess: React.FC<WebinarRegistrationSuccessProps> = ({ courseInfo, ctas }) => {
  return (
    <div className="border-gray-200 mx-auto mt-[70px] h-[400px] max-w-[650px] rounded-lg  bg-white p-8 shadow-md">
      <div className="mb-6 flex flex-col items-center ">
        <div className="bg-green-500 mb-4 flex h-16 w-16 items-center justify-center rounded-full">
          <svg
            fill="none"
            height="73"
            viewBox="0 0 73 73"
            width="73"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clip-rule="evenodd"
              d="m36.5 63.5c-14.913 0-27-12.087-27-27s12.087-27 27-27 27 12.087 27 27-12.087 27-27 27z"
              fill="#42be65"
              fill-rule="evenodd"
            />
            <path
              d="m48.5 30.5-15 15-9-9"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="4.5"
            />
          </svg>
        </div>
        <h2 className="text-gray-800 mb-2 text-title-32 font-bold">
          Your registration is successful
        </h2>
        <p className="text-grey-3 text-body-16">
          You&apos;ll soon receive an email with joining details.
        </p>
      </div>

      <div className="bg-gray-100 rounded-lg p-4 ">
        <div className="mb-4 flex gap-2">
          <div className="relative mr-4 h-36 w-36">
            <Image
              src={courseInfo.instructorImage || '/default-instructor-image.jpg'}
              alt="Instructor"
              layout="fill"
              objectFit="cover"
              className="rounded-lg"
            />
          </div>
          <div className="flex flex-col justify-between gap-2">
            <h3 className="text-gray-800 text-title-20 font-semibold">
              {courseInfo.title}
            </h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-center gap-2">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect y="0.5" width="32" height="32" rx="4" fill="#F1F0FF" />
                  <path
                    d="M12.9975 10.4976V12.4984"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M18.9995 10.4976V12.4984"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.99805 14.8327H22.003"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <rect
                    x="9.99805"
                    y="11.498"
                    width="12.005"
                    height="11.0046"
                    rx="2"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className="text-gray-600 text-body-14">{courseInfo.date}</span>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect y="0.5" width="32" height="32" rx="4" fill="#F1F0FF" />
                  <path
                    d="M19.2107 16.5796H16.1094"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="16.5103"
                    cy="16.1778"
                    r="6.0025"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M16.1089 16.5795V12.8431"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span className="text-gray-600 text-body-14">{courseInfo.time}</span>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect y="0.5" width="32" height="32" rx="4" fill="#F1F0FF" />
                  <path
                    d="M12.5 11.1666H20.5"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.5 21.8333H20.5"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.834 11.1667V13.8334C13.834 14.2534 14.0313 14.648 14.3673 14.9L16.5007 16.5L18.634 14.9C18.97 14.648 19.1673 14.2534 19.1673 13.8334V11.1667"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.1673 21.8333V19.1667C19.1673 18.7467 18.97 18.352 18.634 18.1L16.5007 16.5L14.3673 18.1C14.0313 18.352 13.834 18.7467 13.834 19.1667V21.8333"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className="text-gray-600 text-body-14">
                  {courseInfo.duration}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect y="0.5" width="32" height="32" rx="4" fill="#F1F0FF" />
                  <path
                    d="M10.498 21.1686V21.1686C10.4984 19.7252 11.6684 18.5552 13.1118 18.5549H15.7256C17.1689 18.5552 18.3389 19.7252 18.3393 21.1686V21.1686"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.627 11.8314C22.7928 12.9972 22.7928 14.8873 21.627 16.0531"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19.6442 12.8871C20.2271 13.4701 20.2271 14.4151 19.6442 14.998"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <circle
                    cx="14.4176"
                    cy="14.1657"
                    r="2.16757"
                    stroke="#6059FF"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className="text-gray-600 text-body-14">
                  {courseInfo.language}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center mt-10 w-full">
        <CtaButtonGroup ctas={ctas} affiliateButton={true} />
      </div>
    </div>
  );
};

export default WebinarRegistrationSuccess;